import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NavSlider from './NavSlider';
import MainSlider from './MainSlider';

export default class DoubleSlickSlider extends Component {
  state = {
    activeSlide: 0,
  }

  render = () => {
    const {
      mainSliderChildren,
      navSliderChildren,
      childrenCount,
      hideNavSlider,
    } = this.props;
    return (
      <React.Fragment>
        <MainSlider
          innerRef={(slider) => {
            this.slider1 = slider;
          }}
          afterChange={(current) => {
            if (!hideNavSlider) {
              this.setState({ activeSlide: current }, () => {
                this.slider2.slickGoTo(this.state.activeSlide);
              });
            }
          }}
        >
          {mainSliderChildren}
        </MainSlider>
        <React.Fragment>
          {(!hideNavSlider && childrenCount > 1) && (
            <React.Fragment>
              <br />
              <NavSlider
                childrenCount={childrenCount}
                innerRef={(slider) => {
                  this.slider2 = slider;
                }}
                afterChange={(current) => {
                  this.setState({ activeSlide: current }, () => {
                    this.slider1.slickGoTo(this.state.activeSlide);
                  });
                }}
                activeSlide={this.state.activeSlide}
              >
                {navSliderChildren}
              </NavSlider>
            </React.Fragment>
          )}
        </React.Fragment>
      </React.Fragment>
    );
  }
}

DoubleSlickSlider.propTypes = {
  mainSliderChildren: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  navSliderChildren: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  childrenCount: PropTypes.number.isRequired,
  hideNavSlider: PropTypes.bool,
};

DoubleSlickSlider.defaultProps = {
  hideNavSlider: false,
};
